import { api } from './api.js'

/**
 * POST /orders
 * payload: { client_id, user_id, ordered_at, status_id,
 *            order_details_attributes: [{product_id, quantity, unit_price}] }
 */
export async function createOrder(payload) {
  return api.post('/orders', { order: payload })
}

/**
 * GET /orders?chain_id=X&per_page=200
 * Returns { orders: [...] } — each order has order_status_id, client, ordered_at, order_details
 */
export async function getOrders(params = {}) {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined))
  ).toString()
  return api.get(`/orders${qs ? '?' + qs : ''}`)
}

/**
 * GET /orders/:id
 * Returns { order: { ..., order_details: [...] } }
 */
export async function getOrder(id) {
  return api.get(`/orders/${id}`)
}
